import { HtsClassificationTopic, HtsTopicKind } from "../constants";
import { HtsClassificationTopicConfig } from "../schemas";
import { HTS_ISOLATED_OLD_INCIDENT_NOTE } from "./sharedNotes";

export const drivingRecordBehaviour: HtsClassificationTopicConfig = {
  id: HtsClassificationTopic.DRIVING_RECORD_BEHAVIOUR,
  label: "Driving record and behaviours",
  kind: HtsTopicKind.Suitability,
  narrativeFields: [
    "how often the behaviour occurs, or how it happened",
    "how recently",
    "what's changed since (for ongoing behaviours like distracted driving or speeding)",
    "for an accident: when, whether other vehicles were involved, who was at fault, and the outcome",
    "for a suspension: the reason and duration",
  ],
  followUpTriggers: [
    "it's unclear whether the pattern is ongoing or has changed",
    "fault or outcome for an accident is unclear",
    "the reason or duration for a suspension is missing",
  ],
  hardBarrierFacts: [
    "dangerous driving or street racing — skips follow-ups entirely, immediate high priority",
  ],
  crossCuttingNotes: [
    "distracted driving and speeding are almost-universal 'yes' answers — the follow-up asks how often, how recently, and what's changed, and honest answers become coaching notes rather than flags",
    "an isolated, not-at-fault accident resolves on its own; a pattern goes to a person",
    HTS_ISOLATED_OLD_INCIDENT_NOTE,
    "impaired driving is at minimum a standard flag; within the last five years, high priority — the same cross-cutting rule as the criminal-charges category, since impaired driving surfaces through either question",
  ],
};
